import { useState, useEffect } from "react";
import { Code } from "lucide-react";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className={`fixed top-0 w-full backdrop-blur-md border-b border-gray-200/50 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95' : 'bg-white/90'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-3" data-testid="logo-section">
            <div className="w-8 h-8 sprintwise-gradient rounded-lg flex items-center justify-center">
              <Code className="text-white text-sm" />
            </div>
            <span className="text-xl font-bold sprintwise-text-gradient">Sprintwise</span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8" data-testid="main-navigation">
            <button 
              onClick={() => scrollToSection('services')} 
              className="text-gray-700 hover:text-primary transition-colors"
              data-testid="nav-services"
            >
              Услуги
            </button>
            <button 
              onClick={() => scrollToSection('tech')} 
              className="text-gray-700 hover:text-primary transition-colors"
              data-testid="nav-tech"
            >
              Технологии
            </button>
            <button 
              onClick={() => scrollToSection('cases')} 
              className="text-gray-700 hover:text-primary transition-colors"
              data-testid="nav-cases"
            >
              Кейсы
            </button>
            <button 
              onClick={() => scrollToSection('team')} 
              className="text-gray-700 hover:text-primary transition-colors"
              data-testid="nav-team"
            >
              Команда
            </button>
            <button 
              onClick={() => scrollToSection('faq')} 
              className="text-gray-700 hover:text-primary transition-colors"
              data-testid="nav-faq"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="sprintwise-gradient text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all duration-300"
              data-testid="nav-contact-cta"
            >
              Обсудить проект
            </button>
          </nav>
          
          <button className="md:hidden p-2" data-testid="mobile-menu-button">
            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
